import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DashboardService from "services/dashboardService";

export const initialState = {
  list: [
    {
      title: "Result Report",
      type: "pie",
      series: [0, 0, 0, 0],
      labels: ["Panic", "Confidential", "Completed", "Partial"],
      colors: ["#1E90FF", "#32CD32", "#FFD700", "#FF6347"],
      options: {
        plotOptions: {
          pie: {
            size: "80%",
          },
        },
      },
    },
    {
      title: "Order Report",
      type: "pie",
      series: [0, 0],
      labels: ["Agency Orders", "Inhouse Orders"],
      colors: ["#1E90FF", "#32CD32"],
      options: {
        plotOptions: {
          pie: {
            size: "80%",
          },
        },
      },
    },
    {
      title: "Patients Count",
      type: "pie",
      series: [0, 0],
      labels: ["female", "male"],
      colors: ["#1E90FF", "#32CD32"],
      options: {
        plotOptions: {
          pie: {
            size: "80%",
          },
        },
      },
    },
  ],
  loading: false,
  otherReports: [],
  BarandLineChartsData: [],
  receptionData: [],
  monthlyRevenueComparisonByMonth: {},
  topClients: [],
  errorMessages: [],
  showMessage: false,
};

export const fetchDashboardReport = createAsyncThunk(
  "/fetchDashboardReport",
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.fetchReport(params);
      const code = response.code;
      console.log('Dashboard report response of reception data:', response.receptionData);
      return {
        code: code,
        report: response.data,
        otherReports: response.otherReports,
        BarandLineChartsData: response.BarandLineChartsData,
        receptionData: response.receptionData,
        monthlyRevenueComparisonByMonth: response.monthlyRevenueComparisonByMonth,
        paymentReport: response.paymentReport,
        patientsCount: response.patientsCount,
        topClients: response.topClients,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a role",
        }
      );
    }
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.report;
        state.otherReports = action.payload.otherReports;
        state.BarandLineChartsData = action.payload.BarandLineChartsData;
        state.receptionData = action.payload.receptionData;
        state.monthlyRevenueComparisonByMonth = action.payload.monthlyRevenueComparisonByMonth || {};
        state.paymentReport = action.payload.paymentReport || {};
        state.patientsCount = action.payload.patientsCount || {};
        state.topClients = action.payload.topClients || [];
      })
      .addCase(fetchDashboardReport.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = dashboardSlice.actions;

export default dashboardSlice.reducer;
